<template>
    <div class="modal fade" id="change-period-modal" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content" style="min-height: 600px;">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <span>Ändra period</span>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal">
                        <span><b>x</b></span>
                    </button>
                </div>
                <div class="modal-body pb-5">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{ transEdit('start') }}</label>
                                <input v-if="batch" type="date" class="form-control" name="period_start_period" id="period_start_period" :value="getDate(this.batch.period_start)" disabled>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{ transEdit('end') }}</label>
                                <input v-if="!loading" type="date" class="form-control" name="period_end_period" id="period_end_period" autocomplete="off">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <label for="message">{{ transEdit('Valfritt meddelande till avbokade kunder') }}</label>
                            <textarea name="message" class="form-control" v-model="message"></textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <label for="message">{{ transEdit('Förläng från datum') }}</label>
                            <input name="from_date" type="date" class="form-control" v-model="from_date">
                        </div>
                    </div>
                    <div class="row pb-20">
                        <div class="col-md-6">
                            <div>
                                <span v-if="loading"><i class="fa fa-spin fa-fw fa-refresh"></i>{{ transEdit('loading') }}...</span>
                            </div>
                            <div class="text-danger">
                                <span v-if="error">{{ transEdit('admin.schedules.create.conflicts-exist') }}</span>
                            </div>
                            <input class="hidden" id="change-period-modal-batch-hidden" v-model-inject="batch_id">
                            <input class="hidden" id="change-period-modal-date">
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" v-on:click="updatePeriod"><i class="fa fa-pencil"></i> Ändra period</button>
                    <button class="btn btn-dark" data-dismiss="modal"><i class="fa fa-ban"></i> {{ transEdit('cancel') }}</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import VueMultiselect from "vue-multiselect/src/Multiselect";

export default {
    name: "admin-schedules-batch-modal-change-period",
    components: {VueMultiselect},

    data() {
        return {
            loading: true,
            error: false,
            batch_id: null,
            batch: null,
            start: null,
            end: null,
            message: '',
            from_date: '',
        }
    },
    methods: {
        updatePeriod: function () {
            this.error = false;
            this.loading = true;
            let thisModal = $("#change-period-modal");

            axios.post(this.$portalUrl('adminschedule/batch/changeperiod'), {
                batch_id: this.batch_id,
                current_date: $("#change-period-modal-date").val(),
                start: $("#period_start_period").val(),
                end: $("#period_end_period").val(),
                message: this.message,
                from_date: this.from_date,
            }).then((res) => {
                this.loading = false;
                this.$emit('refresh');
                thisModal.modal('toggle');
            }).catch((res) => {
                this.error = true;
            });
        },
        getBatch() {
            axios.get('adminschedule/batch/' + this.batch_id).then((res) => {
                this.batch = res.data;
                this.end = this.getDate(this.batch.period_end);
                this.loading = false;
            });
        },
        getTreatmentIds() {
            if (!this.selectedTreatment || !this.selectedTreatment.length) return [];
            let ids = [];
            for (let treatment of this.selectedTreatment) {
                ids.push(treatment.id);
            }

            return ids;
        },
        getDate(dateString) {
            return moment(dateString).format('YYYY-MM-DD')
        },
    },
    watch: {
        'batch_id': function (val, oldVal) {
            this.getBatch();
            this.loading = false;
        }
    },
    mounted() {
        this.loading = true;
    }
}
</script>

<style scoped>

</style>
